import BaseModel from './Base.model';

export class PreorderProgramModel extends BaseModel {
  constructor(data = {}) {
    super({
      id: data.id ?? null,
      createdAt: data.createdAt ?? null,
      updatedAt: data.updatedAt ?? null,
    });
    this.name = data.name ?? '';
    this.code = data.code ?? '';
    this.type = data.type ?? null;
  }

  static fromJson(data) {
    return BaseModel.fromJson(data, PreorderProgramModel);
  }

  static fromJsonArray(dataArray) {
    return BaseModel.fromJsonArray(dataArray, PreorderProgramModel);
  }
}
